module.exports = __webpack_public_path__ + "static/media/woocommerce.75a3b44b.svg";